export default "__VITE_ASSET__ieJLw_g$__"